import type { ReactNode } from 'react'
import { UtilityBanner } from '@/components/site/UtilityBanner'
import { SiteHeader } from '@/components/site/SiteHeader'
import { Footer } from '@/components/site/Footer'

/**
 * Standard page chrome — banner + header + content + footer. Used by every
 * non-homepage route. The homepage composes its own layout because its hero
 * section is full-bleed.
 *
 * `minimalHeader` strips the header down to brand + theme toggle (no nav / auth
 * menu) for focused flows like /reset-password.
 */
export function SiteLayout({
  children,
  minimalHeader = false,
}: {
  children: ReactNode
  minimalHeader?: boolean
}) {
  return (
    <div className="flex min-h-[100dvh] flex-col bg-[var(--color-surface)]">
      <UtilityBanner />
      <SiteHeader minimal={minimalHeader} />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  )
}
